// src/modules/Courier/pages/CourierModal/pages/ReceiptMapPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../../services/api';
import MapComponent from '../components/MapComponent';
import styles from '../styles/ReceiptMapPage.module.css';
import { useRouteStore } from '../../Route/useRouteStore';

export default function ReceiptMapPage({ receiptId }) {
  const navigate = useNavigate();

  // Экшен для синхронизации квитанции в сторе
  const updateReceipt = useRouteStore(s => s.updateReceipt);

  // Локальный стейт
  const [receiptDetails, setReceiptDetails] = useState(null);
  const [mapCenter, setMapCenter]         = useState(null);
  const [isLoading, setIsLoading]         = useState(true);
  const [error, setError]                 = useState('');
  const setSelectedReceiptId = useRouteStore(s => s.setSelectedReceiptId);
  const setModalPage         = useRouteStore(s => s.setModalPage);

  // Геопозиция пользователя
  const [userLocation, setUserLocation]   = useState(null);
  const defaultZoom = 15;

  // Загрузка квитанции и синхронизация со стором
  useEffect(() => {
    async function fetchReceipt() {
      setIsLoading(true);
      setError('');
      try {
        // API возвращает объект квитанции напрямую
        const fresh = await api.get(`/receipts/${receiptId}`);

        // сохраняем локально
        setReceiptDetails(fresh);

        // пушим в Zustand + React Query
        updateReceipt(fresh);

        // вычисляем центр карты
        const lat = parseFloat(fresh.latitude);
        const lng = parseFloat(fresh.longitude);
        setMapCenter(
          !isNaN(lat) && !isNaN(lng)
            ? [lat, lng]
            : [55.7558, 37.6176]
        );
      } catch (e) {
        console.error('Ошибка загрузки квитанции:', e);
        setError(e.response?.message || 'Ошибка при загрузке данных');
      } finally {
        setIsLoading(false);
      }
    }
    fetchReceipt();
  }, [receiptId, updateReceipt]);

  // Запрос геопозиции один раз
  useEffect(() => {
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(
      pos => setUserLocation([pos.coords.latitude, pos.coords.longitude]),
      () => {},
      { enableHighAccuracy: true, timeout: 5000 }
    );
  }, []);

  const handleGoBack      = () => navigate(-1);
  const handleMarkerClick = () => {
    setSelectedReceiptId(receiptId);
    setModalPage('receipt');
    };
  if (isLoading) {
    return <div className={styles.loading}>Загрузка карты...</div>;
  }
  if (error) {
    return (
      <div className={styles.error}>
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>Попробовать снова</button>
      </div>
    );
  }
  if (!receiptDetails || !mapCenter) {
    return <div className={styles.error}>Не удалось загрузить данные</div>;
  }

  return (
    <div className={styles.root}>
      {/*<button className={styles.backButton} onClick={handleGoBack}>
        ← Назад
      </button>*/}
      <div className={styles.mapContainer}>
        <MapComponent
          center={mapCenter}
          zoom={defaultZoom}
          receipts={[receiptDetails]}
          onMarkerClick={handleMarkerClick}
          userLocation={userLocation}
        />
      </div>
    </div>
  );
}
